const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    desktop: 1200,
    tablet: 808,
    xl: 1536
  }
};
const EXTRA_SMALL = "xs";
const SMALL = "sm";
const MEDIUM = "md";
const LARGE = "lg";
const EXTRA_LARGE = "xl";
export {
  EXTRA_LARGE,
  EXTRA_SMALL,
  LARGE,
  MEDIUM,
  SMALL,
  breakpoints
};
